import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PortalService } from '../portal.service';

@Component({
    selector: 'portal-register',
    templateUrl: './portal-register.component.html'
})
export class PortalRegisterComponent implements OnInit {
    webUserFatherName: string = "";
    modelRegister: any = {};
    public right_side_bar: boolean;
    constructor(public translate: TranslateService,
                private portalService: PortalService) { }
    ngOnInit() {
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        if (browserWindowEnv.hasOwnProperty('webUserFatherName') &&
            window['__env']['webUserFatherName'] == "true") {
            this.webUserFatherName = window['__env']['webUserFatherName'];
        }
    }

    register() {
        this.portalService.register(this.modelRegister);
    }
}
